export const PROJECT_TIME_ZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
];

export const getShortTimeZoneName = (timeZone: string) => {
  try {
    return (
      new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'short',
      })
        .formatToParts(new Date())
        .find((part) => part.type === 'timeZoneName')?.value || timeZone
    );
  } catch {
    return timeZone;
  }
};

export const getProjectTimeZoneLabel = (timeZone: string) => {
  const displayName = timeZone.split('/').slice(1).join('/').replace(/_/g, ' ') || timeZone;
  return `${displayName} (${getShortTimeZoneName(timeZone)})`;
};
